import React__default, { useRef, useMemo, useCallback } from 'react';
import { Accordion } from '@sravni/react-design-system/lib/Accordion';
import { Space } from '@sravni/react-design-system/lib/Space';
import { promoParam } from '../../../consts/links.js';
import { useAnalyticEvents } from '../../../hooks/useAnalyticEvents.js';
import { useCreateIntersectionObserverRefs } from '../../../hooks/useCreateIntersectionObserverRefs.js';
import { defaultMobileMenu } from '../../../mocks/defaultMobileMenu.js';
import { flatMenuLinks } from '../../../utils/menu.js';
import { getCustomStyles } from '../../../utils/styles.js';
import { MenuItem } from '../../MenuItem/src/MenuItem.js';
import '../../Providers/CustomPropsProvider/src/CustomPropsProvider.js';
import { useCustomProps } from '../../Providers/CustomPropsProvider/hooks/useCustomProps.js';

const MobileMenu = (props) => {
    const { onChange, ...restProps } = props;
    const { settings = {} } = useCustomProps();
    const { pushAnalyticEvent } = useAnalyticEvents();
    const previousAccordionIndexesLengthRef = useRef(0);
    const { mobileMenu: menu = defaultMobileMenu } = settings;
    const mobileMenuTopLinksText = useMemo(() => menu.map((o) => o.text).filter((o) => o !== ''), [menu]);
    const promoLinks = useMemo(() => flatMenuLinks(menu).filter((item) => item.href?.includes(promoParam)), [menu]);
    const handleAccordionChange = useCallback((currentIndexes) => {
        onChange?.(currentIndexes);
        const previousAccordionIndexesLength = previousAccordionIndexesLengthRef.current;
        const currentAccordionIndexesLength = currentIndexes.length;
        const isExpandAction = currentAccordionIndexesLength > previousAccordionIndexesLength;
        const label = mobileMenuTopLinksText[currentIndexes[currentAccordionIndexesLength - 1]];
        if (isExpandAction)
            pushAnalyticEvent("topMenuShow" /* EVENTS.TOP_MENU_SHOW */, { eventLabel: `${label}|Клик` });
        previousAccordionIndexesLengthRef.current = currentAccordionIndexesLength;
    }, [mobileMenuTopLinksText, onChange, pushAnalyticEvent]);
    const handleMenuItemClick = useCallback((event) => {
        event.stopPropagation();
        const label = event.currentTarget.dataset.label || '';
        const section = event.currentTarget.dataset.section || '';
        pushAnalyticEvent("menuLinkClick" /* EVENTS.MENU_LINK_CLICK */, { eventLabel: `${section}|${label}` });
    }, [pushAnalyticEvent]);
    const handlePromoLinkIntersectionChange = useCallback((data) => {
        const { inView, item, entry } = data;
        const { text, href } = item;
        const target = entry?.target ? entry.target : undefined;
        const section = target?.dataset?.section || '';
        if (inView) {
            pushAnalyticEvent("promoLinkInView" /* EVENTS.PROMO_LINK_IN_VIEW */, { eventLabel: `${section}|${text}|${href}` });
        }
    }, [pushAnalyticEvent]);
    const { refs: promoIntersectionRefs, getRefKey: getPromoRefKey } = useCreateIntersectionObserverRefs({
        items: promoLinks,
        onChange: handlePromoLinkIntersectionChange,
    });
    return (React__default.createElement(Accordion, { scrollIntoView: true, "data-qa": "Navigation", ...restProps, onChange: handleAccordionChange }, menu.map((section) => (React__default.createElement(Accordion.Item, { key: section.text, "data-label": section.text, title: section.text, style: getCustomStyles(section), unmountOnExit: false }, Array.isArray(section?.children) && section?.children.length > 0 && React__default.createElement(Space, { size: 16, direction: "vertical" }, section.children?.map((submenus) => (React__default.createElement(Space, { size: 16, direction: "vertical", key: submenus.text }, submenus.children?.map((menuItem) => (React__default.createElement(MenuItem, { ref: promoIntersectionRefs[getPromoRefKey(menuItem)], key: menuItem.href, item: menuItem, "data-section": section.text, onClick: handleMenuItemClick }))))))))))));
};
MobileMenu.displayName = 'MobileMenu';

export { MobileMenu };
//# sourceMappingURL=MobileMenu.js.map
